module.exports = __webpack_public_path__ + "static/media/cevt.43896fe5.svg";